import dayjs from "dayjs";
import { supabase } from "../../../consts/supabaseClient.js";
import { BACKEND_DATE_FORMAT } from "../../../consts/index.js";

const TABLE = "HarvestRequirements";
const normISO = (dateStr) =>
  dayjs(dateStr).startOf("day").format(BACKEND_DATE_FORMAT);

export const hrqGetAll = async (siteId) => {
  const { data, error } = await supabase
    .from(TABLE)
    .select("date, value, type")
    .eq("site_id", String(siteId));
  if (error) throw error;

  const out = {};
  for (const r of data || []) {
    const iso = dayjs(r.date).format(BACKEND_DATE_FORMAT);
    out[iso] = { value: r.value, type: r.type };
  }
  return out;
};

/** Load requirements for a date range (inclusive). Returns map { iso: { value, type } }. */
export const hrqGetRange = async (siteId, startISO, endISO) => {
  const { data, error } = await supabase
    .from(TABLE)
    .select("date, value, type")
    .eq("site_id", String(siteId))
    .gte("date", normISO(startISO))
    .lte("date", normISO(endISO));
  if (error) throw error;

  const out = {};
  for (const r of data || []) {
    const iso = dayjs(r.date).format(BACKEND_DATE_FORMAT);
    out[iso] = { value: r.value, type: r.type };
  }
  return out;
};

/**
 * Upsert a list of inputs. Zeros delete the row at (site_id,date).
 * @param {HarvestRequirementInput[]} inputs
 * @returns {{ok:true,saved:number}}
 */
export const hrqSaveMany = async (inputs) => {
  if (!inputs?.length) return { ok: true, saved: 0 };

  const siteId = String(inputs[0].siteId);
  const toUpsert = [];
  const toDeleteDates = [];

  for (const item of inputs) {
    const iso = normISO(item.date);
    const count = Number(item.value) || 0;

    if (count <= 0) {
      toDeleteDates.push(iso);
    } else {
      toUpsert.push({
        org_id: item.orgId,
        site_id: siteId,
        crop_id: item.cropId,
        date: iso,
        type: item.type,
        value: count,
      });
    }
  }

  if (toUpsert.length) {
    const { error } = await supabase
      .from(TABLE)
      .upsert(toUpsert, { onConflict: "site_id,date" });
    if (error) throw error;
  }

  if (toDeleteDates.length) {
    const { error } = await supabase
      .from(TABLE)
      .delete()
      .eq("site_id", siteId)
      .in("date", toDeleteDates);
    if (error) throw error;
  }

  return { ok: true, saved: inputs.length };
};

export const hrqClearSite = async (siteId) => {
  const { error } = await supabase
    .from(TABLE)
    .delete()
    .eq("site_id", String(siteId));
  if (error) throw error;
  return { ok: true };
};
